module.exports = {
      id: "connection-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#connection-usage",
      toString: function () {
        return this.url;
      }
    }